import { render, staticRenderFns } from "./CreateTicketOpr.vue?vue&type=template&id=becf4124"
import script from "./CreateTicketOpr.vue?vue&type=script&lang=ts"
export * from "./CreateTicketOpr.vue?vue&type=script&lang=ts"
import style0 from "./CreateTicketOpr.vue?vue&type=style&index=0&id=becf4124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports